import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { MatrixProvider, NotificationManager, Tooltip } from '@adsk/bim360-matrix-react-components';
import { connect } from '../../redux/connect';
import {
  getNotification,
  getMatrixConfig,
  getCurrentProject,
  getCurrentUser,
} from '../../redux/selectors';
import { resetNotification } from '../../redux/actions';
import Routes from './Routes';
import { historyAttributesType } from '../../constants/proptype-validation';
import ControllableIFrameModal from '../../components/ControllableIFrameModal';
import { getLanguage } from '../../utils/i18n';

export class PureMain extends PureComponent {
  static displayName = 'Main';

  static propTypes = {
    history: historyAttributesType.isRequired,
    currentUser: PropTypes.object,
    currentProject: PropTypes.object,
    matrixConfig: PropTypes.object,
    notification: PropTypes.object,
    resetNotification: PropTypes.func.isRequired,
  };

  /**
   * componentDidUpdate
   */
  componentDidUpdate(prevProps) {
    const { notification, resetNotification } = this.props;

    if (notification && notification !== prevProps.notification) {
      this.notificationManager.addNotification({
        level: notification.level,
        autoDismiss: notification.autoDismiss, // if we don't pass autoDismiss the default is 6 seconds
        type: notification.type,
        message: notification.message,
        asyncOperation: notification.asyncOperation,
        closeButtonRenderer: notification.closeButtonTooltipText
          ? this.getNotificationCloseButtonRenderer(notification.closeButtonTooltipText)
          : undefined,
      });

      // Resetting the notification in the store so that components that rely on the the notification in the store will be updated and won't "remember" an unrelated notification.
      resetNotification();
    }
  }

  /**
   * Return close button renderer
   * @param closeButtonTooltipText
   * @returns {function({getCloseButton: *, asyncOperationResult?: *})}
   */
  getNotificationCloseButtonRenderer(closeButtonTooltipText) {
    return ({ getCloseButton, asyncOperationResult }) => {
      if (asyncOperationResult && asyncOperationResult.success) {
        return getCloseButton();
      }
      return (
        <Tooltip
          content={closeButtonTooltipText}
          style={{ zIndex: 10000 }}
          theme={Tooltip.Themes.DARK}
          place={Tooltip.Places.LEFT}
        >
          {getCloseButton()}
        </Tooltip>
      );
    };
  }

  render() {
    const { history, matrixConfig, currentProject, currentUser } = this.props;
    return (
      <Fragment>
          <MatrixProvider
            locale={getLanguage()}
            env={matrixConfig.env}
            region={matrixConfig.region}
            project={currentProject}
            currentUser={currentUser}
          >
            <Routes {...{ history }} />
            <ControllableIFrameModal />
            <NotificationManager
              ref={(n) => {
                this.notificationManager = n;
              }}
            />
          </MatrixProvider>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  notification: getNotification(state),
  matrixConfig: getMatrixConfig(state),
  currentUser: getCurrentUser(state),
  currentProject: getCurrentProject(state),
});

const mapDispatchToProps = () => ({
  resetNotification,
});

export default connect(mapStateToProps, mapDispatchToProps)(PureMain);
